import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Spinner } from 'reactstrap';
import oktaAuth from 'services/okta';
import { loginWithOkta } from 'slices/userSlice';

function OktaCallback() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [error, setError] = useState(null);

    useEffect(() => {
        const handleCallback = async () => {
            try {
                await oktaAuth.handleLoginRedirect();
                const idToken = oktaAuth.getIdToken();

                if (!idToken) {
                    throw new Error('No ID token received from Okta');
                }

                dispatch(loginWithOkta(idToken, (success) => {
                    if (success) {
                        toast.success('Login Successfully', { className: 'successToast' });
                        navigate('/', { replace: true });
                    } else {
                        toast.error('SSO login failed. Please try again.', { className: 'errorToast' });
                        navigate('/login', { replace: true });
                    }
                }));
            } catch (err) {
                console.error('Okta callback error:', err);
                setError(err.message);
                toast.error('SSO login failed. Please try again.', { className: 'errorToast' });
                navigate('/login', { replace: true });
            }
        };

        handleCallback();
    }, []);

    if (error) {
        return null;
    }

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', background: 'linear-gradient(to bottom, #7b8cde, #56ccf2)' }}>
            <div style={{ textAlign: 'center', color: '#fff' }}>
                <Spinner style={{ width: '3rem', height: '3rem' }} />
                <p style={{ marginTop: '1rem', fontSize: '1.1rem' }}>Completing login...</p>
            </div>
        </div>
    );
}

export default OktaCallback;
